import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FAutocomplete } from '../../../../../../../components/baseV2';
import TrashIcon from '../../../../../../../components/svgs/TrashIcon';
import { FORTA_BLUE } from '../../../../../../../utils/colors';
import {
  TECHNIQUE_DELETE_BUTTON_SX,
  TECHNIQUE_FIELD_ROOT_SX,
  TECHNIQUE_SELECTED_ITEM_SX,
  TECHNIQUE_SELECTED_LIST_SX,
} from './styles';

import type { SyntheticEvent } from 'react';
import type { IOption } from '../../../../../../../utils/types';
import type { TechniqueUsedFieldProps } from './types';

export default function TechniqueUsedField({
  disabled,
  options,
  selectedTechniqueCodes,
  showError,
  onChange,
}: TechniqueUsedFieldProps) {
  const { t } = useTranslation('sessionNotes');
  const selectedOptions = options.filter((option) =>
    selectedTechniqueCodes.includes(String(option.id)),
  );

  const handleChange = (_event: SyntheticEvent, selectedOptions: IOption[]) => {
    onChange(selectedOptions.map((option) => String(option.id)));
  };

  const renderNoTags = () => null;

  const handleDelete = (techniqueCode: string) => {
    onChange(selectedTechniqueCodes.filter((selectedCode) => selectedCode !== techniqueCode));
  };

  return (
    <Box sx={TECHNIQUE_FIELD_ROOT_SX}>
      <FAutocomplete<IOption, true, false, false>
        label={t('goalsPracticed.techniqueUsed')}
        required
        fullWidth
        multiple
        disableCloseOnSelect
        disabled={disabled}
        options={options}
        value={selectedOptions}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        placeholder={t('goalsPracticed.selectTechniqueUsed')}
        renderTags={renderNoTags}
        error={showError && selectedTechniqueCodes.length === 0}
        helperText={
          showError && selectedTechniqueCodes.length === 0
            ? t('goalsPracticed.techniqueUsedRequired')
            : ''
        }
        onChange={handleChange}
      />
      {selectedOptions.length > 0 && (
        <Box sx={TECHNIQUE_SELECTED_LIST_SX}>
          {selectedOptions.map((option) => (
            <Box key={option.id} sx={TECHNIQUE_SELECTED_ITEM_SX}>
              <Typography color={FORTA_BLUE.primary}>{option.label}</Typography>
              {!disabled && (
                <IconButton
                  aria-label={`Remove ${option.label}`}
                  sx={TECHNIQUE_DELETE_BUTTON_SX}
                  onClick={() => handleDelete(String(option.id))}
                >
                  <TrashIcon color={FORTA_BLUE.primary} width={18} height={18} />
                </IconButton>
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
